module.exports = __webpack_public_path__ + "img/18.e9087991.svg";